import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { CardBrands } from 'types';
import { cardBrands } from 'appConstants';
import style from './MainCardBrandSelect.module.scss';

interface IMainCardBrandSelect {
	selectedMainMccCardBrand: CardBrands | null;
	reservedMccCardBrands: (CardBrands | null)[];
	changeMainMccCardBrand: (value: CardBrands) => void;
	useCustomerMcc: boolean;
}

const MainCardBrandSelect: React.FC<IMainCardBrandSelect> = ({
	selectedMainMccCardBrand,
	reservedMccCardBrands,
	changeMainMccCardBrand,
	useCustomerMcc,
}) => {
	const handleChange = (value: CardBrands) => {
		changeMainMccCardBrand(value);
	};

	const mappedOptions = useMemo<ISelectOption[]>(
		() =>
			cardBrands.map((el) => {
				const reservedMccCardBrandsWithExcludedSelfValue = reservedMccCardBrands.filter(
					(reserved) => reserved !== selectedMainMccCardBrand,
				);
				return {
					id: el.id,
					name: el.name,
					disabled: reservedMccCardBrandsWithExcludedSelfValue.includes(el.id),
				};
			}),
		[reservedMccCardBrands],
	);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="MainCardBrandSelect"
			name="mainMccCardBrand"
			label="cardBrandLabel"
			disabled={useCustomerMcc}
			options={mappedOptions}
			onChange={handleChange}
		/>
	);
};

export default React.memo(MainCardBrandSelect);
